import { useContext } from "react";

import EditQuoteContext, { IEditQuoteData } from "components/Quotes/EditQuote/EditQuoteContext";

export function useEditQuoteData(): IEditQuoteData {
    return useContext(EditQuoteContext);
};

export default useEditQuoteData;
